module.exports = __webpack_public_path__ + "static/media/vehicles_dppa.95c7cf98.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/vehicles_dppa.pdf
// module id = 2164
// module chunks = 0